import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";

export type Locale = "th" | "en";

const translations = {
  th: {
    "session.selectClasses": "เลือกชั้นเรียน",
    "session.selectedClasses": "ชั้นเรียนที่เลือก",
    "session.removeClass": "นำ {name} ออก",
    "session.noClasses": "ยังไม่มีชั้นเรียนให้เลือก",
    "session.shuffleAssessments": "สลับลำดับคำถามและตัวเลือกในแบบทดสอบก่อนและหลังเรียน",
    "session.shuffleHelp":
      "ยกเลิกการเลือกเพื่อให้นักเรียนทุกคนในชั้นเรียนที่เปิดครั้งนี้ได้รับคำถามและตัวเลือกตามลำดับเดียวกันในแต่ละแบบทดสอบ",
    "session.openTab": "กิจกรรมที่เปิดอยู่",
    "session.closedTab": "กิจกรรมที่ปิดแล้ว",
    "session.noOpenGroups": "ยังไม่มีกิจกรรมที่เปิดอยู่",
    "session.noClosedGroups": "ยังไม่มีกิจกรรมที่ปิดแล้ว",
    "session.studentCount": "นักเรียน {count} คน",
    "session.noStudents": "ยังไม่มีนักเรียนเข้าร่วม",
    "session.showMore": "แสดงเพิ่มเติม",
    "session.showLess": "แสดงน้อยลง",

    "language.label": "ภาษา",
    "language.thai": "ไทย",
    "language.english": "English",
    "nav.constitution": "สำรวจรัฐธรรมนูญ",
    "nav.about": "เกี่ยวกับ ConLit",
    "nav.join": "เข้าร่วมชั้นเรียน",
    "nav.studentDashboard": "เมนูกิจกรรม",
    "nav.teacher": "พื้นที่ครู",
    "nav.researcher": "พื้นที่นักวิจัย",
    "nav.admin": "ผู้ดูแลระบบ",
    "nav.platform": "ผู้ดูแลแพลตฟอร์ม",
    "nav.signIn": "เข้าสู่ระบบสำหรับบุคลากร",
    "nav.enterPin": "กรอก PIN",
    "nav.signOut": "ออกจากระบบ",
    "nav.leaveDevice": "ออกจากอุปกรณ์นี้",
    "nav.primary": "เมนูหลัก",
    "nav.mobile": "เมนูหลักบนมือถือ",
    "nav.open": "เปิดเมนู",
    "nav.close": "ปิดเมนู",
    "workspace.teacher": "พื้นที่ทำงานของครู",
    "workspace.researcher": "พื้นที่ทำงานของนักวิจัย",
    "workspace.admin": "พื้นที่ทำงานของผู้ดูแลระบบ",
    "workspace.platform": "การดูแลแพลตฟอร์ม",
    "workspace.dashboard": "ภาพรวม",
    "workspace.users": "บัญชีบุคลากร",
    "workspace.audit": "ประวัติการดูแลระบบ",
    "workspace.sessions": "กิจกรรมการเรียนรู้",
    "workspace.classes": "ชั้นเรียน",
    "workspace.studies": "โครงการวิจัยที่ได้รับมอบหมาย",
    "workspace.organisations": "องค์กร",
    "student.activity": "กิจกรรมนักเรียน",
    "footer.tagline": "ConLit · เรียนรู้รัฐธรรมนูญและหน้าที่พลเมืองอย่างเข้าถึงได้",
    "common.loading": "กำลังโหลด",
    "common.retry": "ลองอีกครั้ง",
    "common.refresh": "ตรวจสอบสถานะอีกครั้ง",
    "common.backToActivities": "กลับสู่เมนูกิจกรรม",
    "common.comingSoon": "เร็ว ๆ นี้",
    "common.locked": "ยังไม่เปิด",
    "common.available": "พร้อมทำ",
    "common.inProgress": "กำลังทำ",
    "common.completed": "เสร็จแล้ว",
    "common.open": "เปิดอยู่",
    "common.closed": "ปิดแล้ว",
    "security.checking": "กำลังตรวจสอบความปลอดภัย…",
    "security.unavailable": "ไม่สามารถตรวจสอบความปลอดภัยได้ กรุณารีเฟรชหน้าแล้วลองอีกครั้ง",
    "error.genericTitle": "เกิดข้อผิดพลาด",
    "error.genericDescription": "ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองอีกครั้ง",
    "error.pageTitle": "ไม่สามารถเปิดหน้านี้ได้",
    "error.pageDescription": "กรุณากลับไปหน้าแรกของ ConLit แล้วลองอีกครั้ง",
    "error.unauthorisedTitle": "ไม่สามารถเข้าถึงได้",
    "error.unauthorisedDescription": "บัญชีนี้ไม่มีสิทธิ์เปิดพื้นที่ดังกล่าว",
    "error.returnHome": "กลับหน้าแรก",
    "student.loadingRoom": "กำลังโหลดชั้นเรียน",
    "student.unavailable": "ไม่พบชั้นเรียนของนักเรียน",
    "student.joinAgain": "กรุณาเข้าร่วมชั้นเรียนอีกครั้ง",
    "student.welcome": "ยินดีต้อนรับ {name}",
    "student.dashboardTitle": "เมนูกิจกรรมของฉัน",
    "student.dashboardDescription": "ทำกิจกรรมตามลำดับและรอครูเปิดแบบทดสอบหลังเรียน",
    "student.preTitle": "1. แบบทดสอบก่อนเรียน",
    "student.preDescription": "ทำแบบทดสอบเพื่อสำรวจความรู้ก่อนเริ่มเรียน",
    "student.learnTitle": "2. เรียนรู้ด้วยตนเอง",
    "student.learnDescription": "สำรวจรัฐธรรมนูญและฝึกทักษะผ่านกิจกรรม",
    "student.postTitle": "3. แบบทดสอบหลังเรียน",
    "student.postDescription": "ทบทวนความรู้หลังจบกิจกรรมการเรียนรู้",
    "student.startPre": "เริ่มแบบทดสอบก่อนเรียน",
    "student.resumePre": "ทำแบบทดสอบก่อนเรียนต่อ",
    "student.startPost": "เริ่มแบบทดสอบหลังเรียน",
    "student.resumePost": "ทำแบบทดสอบหลังเรียนต่อ",
    "student.viewResult": "ดูผลคะแนน",
    "student.preRequired": "ทำแบบทดสอบก่อนเรียนให้เสร็จก่อน",
    "student.teacherLocked": "รอครูเปิดแบบทดสอบหลังเรียน",
    "student.constitutionTitle": "คลังรัฐธรรมนูญ",
    "student.constitutionDescription": "ค้นหาและอ่านมาตราตามหัวข้อที่สนใจ",
    "student.mappingTitle": "กิจกรรมจับคู่สิทธิ",
    "student.mappingDescription": "จับคู่สถานการณ์กับสิทธิที่เกี่ยวข้อง",
    "student.scenarioTitle": "สถานการณ์จำลอง",
    "student.scenarioDescription": "อ่านสถานการณ์และอธิบายความคิดเห็นของคุณ",
    "student.resumeScenario": "ทำกิจกรรมต่อ",
    "student.viewCompletion": "ดูสถานะการส่ง",
    "student.flashcardsTitle": "บัตรคำทบทวน",
    "student.openLearning": "เริ่มเรียนรู้",
    "student.noLearning": "ยังไม่มีกิจกรรมเรียนรู้สำหรับห้องนี้",
    "consent.loading": "กำลังโหลดข้อมูลความยินยอม",
    "consent.title": "การเข้าร่วมโครงการวิจัย",
    "consent.description":
      "นักเรียนทำกิจกรรมการเรียนรู้ได้ไม่ว่าจะยินยอมหรือปฏิเสธ หากยินยอม ผลแบบนามแฝงจะรวมอยู่ในสถิติการวิจัยที่ได้รับอนุมัติ นักวิจัยจะไม่เห็นนามแฝง รหัสนักเรียน หรือข้อมูลเข้าสู่ระบบ",
    "consent.saveError": "บันทึกตัวเลือกไม่สำเร็จ",
    "consent.agree": "ยินยอม",
    "consent.decline": "ทำต่อโดยไม่เข้าร่วมวิจัย",
    "assessment.submitted": "ส่งแบบทดสอบเรียบร้อยแล้ว",
    "assessment.score": "คะแนน {earned} จาก {total}",
    "assessment.percentage": "คิดเป็น {percentage}%",
    "assessment.review": "ตรวจคำตอบ",
    "assessment.correct": "ถูกต้อง",
    "assessment.points": "ได้ {earned} จาก {total} คะแนน",
    "assessment.correctAnswer": "คำตอบที่ถูกต้อง: {answer}",
    "assessment.easy": "ระดับง่าย",
    "assessment.advanced": "ระดับขั้นสูง",
    "assessment.questionProgress": "ข้อ {current} จาก {total}",
    "assessment.chooseOne": "เลือกหนึ่งคำตอบ",
    "assessment.previous": "ก่อนหน้า",
    "assessment.next": "ถัดไป",
    "assessment.submit": "ส่งคำตอบ",
    "assessment.submitting": "กำลังส่ง...",
    "assessment.submitError": "ส่งคำตอบไม่สำเร็จ",
    "assessment.notFound": "ไม่พบแบบทดสอบ",
    "assessment.noQuestions": "ไม่พบคำถาม",
    "assessment.noQuestionsDescription": "แบบทดสอบนี้ยังไม่มีคำถาม",
    "assessment.classNotFound": "ไม่พบชั้นเรียน",
    "assessment.invalidLink": "ลิงก์นี้ไม่มีรหัสชั้นเรียน",
    "assessment.loading": "กำลังโหลดแบบทดสอบ",
    "assessment.openError": "เปิดแบบทดสอบไม่ได้",
    "assessment.alreadyCompleted": "ทำแบบทดสอบนี้เรียบร้อยแล้ว",
    "assessment.locked": "ครูยังไม่เปิดแบบทดสอบหลังเรียน",
    "assessment.preRequired": "กรุณาทำแบบทดสอบก่อนเรียนให้เสร็จก่อน",
    "scenario.loading": "กำลังโหลดกิจกรรมสถานการณ์",
    "scenario.notFound": "ไม่พบกิจกรรมสถานการณ์",
    "scenario.openError": "เปิดกิจกรรมสถานการณ์ไม่ได้",
    "scenario.progress": "สถานการณ์ {current} จาก {total}",
    "scenario.answerHelp": "เขียนคำตอบของคุณ ({count}/{max} ตัวอักษร)",
    "scenario.submit": "ส่งคำตอบทั้งหมด",
    "scenario.submitting": "กำลังส่ง...",
    "scenario.submitError": "ส่งคำตอบไม่สำเร็จ",
    "scenario.completeTitle": "ส่งคำตอบเรียบร้อยแล้ว",
    "scenario.completeDescription": "ขอบคุณที่ทำกิจกรรมวิเคราะห์สถานการณ์ครบทุกข้อ",
    "mapping.title": "จับคู่สถานการณ์กับสิทธิ",
    "mapping.description": "ลากการ์ดไปยังคำตอบ หรือใช้ตัวเลือกสำหรับแป้นพิมพ์ด้านล่าง",
    "mapping.situation": "นักเรียนแสดงความคิดเห็นโดยสงบ",
    "mapping.expression": "เสรีภาพในการแสดงความคิดเห็น",
    "mapping.privacy": "สิทธิในความเป็นส่วนตัว",
    "mapping.keyboard": "ตัวเลือกสำหรับแป้นพิมพ์",
    "mapping.instruction": "เลือกสิทธิที่ตรงกับสถานการณ์นักเรียนแสดงความคิดเห็นโดยสงบ",
    "mapping.check": "ตรวจคำตอบ",
    "mapping.reset": "เริ่มใหม่",
    "mapping.correct": "ถูกต้อง สถานการณ์นี้เกี่ยวข้องกับเสรีภาพในการแสดงความคิดเห็น",
    "mapping.incorrect": "ลองอีกครั้ง ลองนึกว่าสิทธิใดคุ้มครองการแสดงความคิดเห็นโดยสงบ",
    "session.loading": "กำลังโหลดกิจกรรมการเรียนรู้",
    "session.title": "กิจกรรมการเรียนรู้",
    "session.description": "เปิดกิจกรรมเดียวกันเป็นห้องแยกที่มี PIN สำหรับแต่ละชั้นเรียน",
    "session.openRooms": "เปิดห้องเรียน",
    "session.sessionTitle": "ชื่อกิจกรรม",
    "session.difficulty": "ระดับแบบทดสอบ",
    "session.easy": "ง่าย",
    "session.advanced": "ขั้นสูง",
    "session.study": "โครงการวิจัย (ไม่บังคับ)",
    "session.noStudy": "ไม่ใช้โครงการวิจัย",
    "session.classes": "ชั้นเรียน",
    "session.learningActivities": "กิจกรรมเรียนรู้",
    "session.learningHelp": "กิจกรรมตัวอย่างถูกเลือกไว้ล่วงหน้า",
    "session.scenario": "สถานการณ์จำลอง (เร็ว ๆ นี้)",
    "session.flashcards": "บัตรคำ (เร็ว ๆ นี้)",
    "session.mapping": "กิจกรรมจับคู่",
    "session.module": "บทเรียน",
    "session.openCount": "เปิด {count} ห้องเรียน",
    "session.openError": "เปิดห้องเรียนไม่สำเร็จ",
    "session.viewRooms": "ดูห้องเรียน",
    "session.noGroups": "ยังไม่มีกลุ่มกิจกรรม",
    "session.statsLoading": "กำลังโหลดสถิติชั้นเรียน",
    "session.unavailable": "ไม่พบกิจกรรม",
    "session.liveStats": "สถิติห้องเรียนอัปเดตทุก 10 วินาที",
    "session.joined": "เข้าร่วมแล้ว",
    "session.preComplete": "ทำก่อนเรียนเสร็จ",
    "session.scenarioComplete": "ส่งกิจกรรมสถานการณ์แล้ว",
    "session.roomScenarioComplete": "ส่งกิจกรรมสถานการณ์แล้ว {count} ครั้ง",
    "session.postComplete": "ทำหลังเรียนเสร็จ",
    "session.pin": "PIN {pin}",
    "session.joinedStatus": "เข้าร่วม {count} คน · {status}",
    "session.preAverage": "เฉลี่ยก่อนเรียน",
    "session.postAverage": "เฉลี่ยหลังเรียน",
    "session.pairedGain": "คะแนนเพิ่มแบบจับคู่",
    "session.studentProgress": "ความคืบหน้าของนักเรียน",
    "session.studentScores": "ก่อน {pre} · หลัง {post}",
    "session.openJoin": "เปิดหน้าเข้าร่วม",
    "session.shareRoom": "ให้นักเรียนสแกน QR หรือกรอก PIN นี้",
    "session.joinQr": "QR สำหรับเข้าร่วมห้องเรียน",
    "session.copyJoinLink": "คัดลอกลิงก์เข้าร่วม",
    "session.registrationOpen": "เปิดรับนักเรียนใหม่",
    "session.registrationLocked": "ปิดรับนักเรียนใหม่",
    "session.lockRegistration": "ปิดรับนักเรียนใหม่",
    "session.unlockRegistration": "เปิดรับนักเรียนใหม่",
    "session.manageRoster": "จัดการรายชื่อ",
    "session.closeRoom": "ปิดห้อง",
    "session.reopenRoom": "เปิดห้องอีกครั้ง",
    "session.postLocked": "แบบทดสอบหลังเรียนปิดอยู่",
    "session.postEnabled": "เปิดแบบทดสอบหลังเรียนแล้ว",
    "session.enablePost": "เปิดแบบทดสอบหลังเรียน",
    "session.disablePost": "ปิดแบบทดสอบหลังเรียน",
    "session.enableAllPost": "เปิดหลังเรียนทุกห้อง",
    "session.disableAllPost": "ปิดหลังเรียนทุกห้อง",
    "session.updateError": "อัปเดตสถานะไม่สำเร็จ",
    "class.loading": "กำลังโหลดชั้นเรียน",
    "class.action": "การดำเนินการ",
    "class.loadError": "โหลดชั้นเรียนไม่สำเร็จ",
    "class.retry": "ลองอีกครั้ง",
    "class.paginationLabel": "การแบ่งหน้าชั้นเรียน",
    "class.pagination": "หน้า {page} จาก {pages} · ทั้งหมด {count} ชั้นเรียน",
    "class.previousPage": "ก่อนหน้า",
    "class.nextPage": "ถัดไป",
    "class.backToClasses": "กลับไปที่ชั้นเรียน",
    "class.codeInstructions":
      "ให้นักเรียนเปิดลิงก์ QR ของรอบกิจกรรมหรือกรอก PIN ชั้นเรียน เลือก “มีรหัสนักเรียนหรือรหัสกู้คืนแล้วใช่ไหม?” แล้วกรอกรหัสส่วนตัวด้านล่าง เก็บรหัสของแต่ละคนไว้เป็นส่วนตัว",
    "class.resetHelp":
      "หากนักเรียนทำรหัสหาย ให้รีเซ็ตการเข้าใช้เพื่อออกรหัสใหม่สำหรับรายชื่อเดิม โดยยังคงความคืบหน้าในการเรียนไว้",
    "class.title": "ชั้นเรียนของคุณ",
    "class.description": "แสดงเฉพาะชั้นเรียนที่บัญชีของคุณเป็นเจ้าของ",
    "class.create": "สร้างชั้นเรียน",
    "class.name": "ชื่อชั้นเรียน",
    "class.prefix": "รหัสย่อชั้นเรียน",
    "class.prefixTitle": "รหัสประจำชั้น",
    "class.prefixHelp":
      "ใช้ตัวอักษรอังกฤษหรือตัวเลข 2–5 ตัว แก้ไขได้ก่อนมีรายชื่อนักเรียนคนแรก รหัสประจำชั้น เช่น CLS-01 ใช้ระบุรายชื่อ ไม่ใช่รหัสสำหรับเข้าใช้งาน",
    "class.savePrefix": "บันทึกรหัสย่อ",
    "class.year": "ปีการศึกษา",
    "class.createAction": "สร้าง",
    "class.createError": "สร้างชั้นเรียนไม่สำเร็จ",
    "class.yearMissing": "ยังไม่ได้ระบุปีการศึกษา",
    "class.manageRoster": "จัดการรายชื่อนักเรียน",
    "class.none": "ยังไม่มีชั้นเรียน",
    "class.noneDescription": "สร้างชั้นเรียนแรกของคุณด้านบน",
    "class.rosterLoading": "กำลังโหลดรายชื่อนักเรียน",
    "class.rosterTitle": "รายชื่อนักเรียน",
    "class.rosterDescription":
      "นักเรียนที่เข้าร่วมด้วยชื่อจะถูกเพิ่มในรายชื่อโดยอัตโนมัติ คุณสามารถเพิ่มนักเรียนล่วงหน้าได้ รหัสส่วนตัวจะแสดงเฉพาะตอนออกหรือรีเซ็ตใหม่",
    "class.addPseudonyms": "เพิ่มนักเรียนล่วงหน้า (ไม่บังคับ)",
    "class.addHelp":
      "กรอกหนึ่งชื่อหรือชื่อเล่นต่อบรรทัด ครั้งละไม่เกิน 100 รายการ นักเรียนที่เพิ่มล่วงหน้าควรใช้รหัสที่ได้รับเพื่อเข้าร่วมด้วยรายชื่อเดิม",
    "class.issueCodes": "สร้างรหัสเข้าใช้งานสำหรับนักเรียน",
    "class.copyCodes": "พิมพ์หรือคัดลอกรหัสเหล่านี้ตอนนี้",
    "class.students": "นักเรียน",
    "class.deviceLinked": "เชื่อมกับอุปกรณ์แล้ว",
    "class.notJoined": "ยังไม่เข้าร่วม",
    "class.reset": "รีเซ็ตการเข้าใช้",
    "class.rename": "แก้ไขชื่อ",
    "class.saveName": "บันทึกชื่อ",
    "class.archive": "นำออก",
    "class.archiveConfirm":
      "นำนักเรียนคนนี้ออกจากรายชื่อที่ใช้งานอยู่หรือไม่ ข้อมูลกิจกรรมเดิมจะยังคงอยู่",
    "research.loading": "กำลังโหลดโครงการวิจัย",
    "research.title": "โครงการวิจัยที่ได้รับมอบหมาย",
    "research.description": "แสดงเฉพาะโครงการที่มอบหมายให้บัญชีนักวิจัยของคุณ",
    "research.none": "ไม่มีโครงการที่ได้รับมอบหมาย",
    "research.statsLoading": "กำลังโหลดสถิติการวิจัย",
    "research.unavailable": "ไม่พบโครงการวิจัย",
    "research.statsTitle": "สถิติห้องเรียนของโครงการ",
    "research.statsDescription":
      "รวมทุกครู · เคารพความยินยอม · ปิดบังกลุ่มที่มีผู้เข้าร่วมน้อยกว่า 5 คน",
    "research.totalSuppressed": "ปิดบังยอดรวมของโครงการ",
    "research.eligible": "ผู้เข้าร่วมที่ใช้วิเคราะห์ได้ {count} คน",
    "research.noIdentities": "ผลระดับห้องไม่แสดงนามแฝงหรือรายชื่อนักเรียน",
    "research.belowFive": "ผู้เข้าร่วมที่ใช้วิเคราะห์ได้น้อยกว่า 5 คน",
    "research.suppressed": "ปิดบังผลลัพธ์",
    "research.fiveRequired": "ต้องมีผู้เข้าร่วมที่ใช้วิเคราะห์ได้อย่างน้อย 5 คน",
    "home.eyebrow": "เรียนรู้สิทธิ ฝึกตัดสินใจ",
    "home.title": "การเรียนรู้พลเมืองที่ทุกคนมีส่วนร่วม",
    "home.description":
      "ConLit ช่วยให้นักเรียนสำรวจสถานการณ์พลเมือง ครูจัดกิจกรรม และนักวิจัยพัฒนาการเรียนรู้จากหลักฐาน",
    "home.join": "เข้าร่วมชั้นเรียน",
    "home.explore": "ทำความรู้จัก ConLit",
    "home.constitutionDescription":
      "ค้นหามาตรา อ่านตามหมวด และดูเนื้อหาฉบับที่ตรวจสอบแหล่งที่มาแล้ว",
    "home.constitutionAction": "เริ่มสำรวจ",
    "home.audiences": "ออกแบบเพื่อชุมชนการเรียนรู้",
    "home.students": "นักเรียน",
    "home.studentsDescription": "เข้าร่วมด้วยนามแฝงและเรียนรู้ผ่านการตัดสินใจ",
    "home.teachers": "ครู",
    "home.teachersDescription": "จัดกิจกรรมและปรับเนื้อหาให้เหมาะกับผู้เรียน",
    "home.researchers": "นักวิจัย",
    "home.researchersDescription": "ศึกษาการมีส่วนร่วมโดยคำนึงถึงความเป็นส่วนตัว",
    "about.title": "เกี่ยวกับ ConLit",
    "about.description":
      "ConLit เป็นแพลตฟอร์มการเรียนรู้รัฐธรรมนูญที่ขับเคลื่อนด้วยเนื้อหา สำหรับนักเรียน ครู นักวิจัย และผู้ดูแลระบบ",
    "privacy.title": "ความเป็นส่วนตัว",
    "privacy.description":
      "ConLit ออกแบบบนหลักการใช้นามแฝง ลดการเก็บข้อมูล เคารพความยินยอม และจำกัดการส่งออกข้อมูลวิจัย",
    "join.pinTitle": "เข้าร่วมชั้นเรียน",
    "join.pinDescription": "ไม่ต้องใช้อีเมล ครูจะให้ PIN 6 ตัวอักษรหรือลิงก์ QR",
    "join.pinLabel": "PIN ชั้นเรียน",
    "join.pinHelp": "ใช้ตัวอักษรและตัวเลขเท่านั้น",
    "join.pinValidation": "กรอก PIN ชั้นเรียน 6 ตัวอักษร",
    "join.continue": "ดำเนินการต่อ",
    "join.pinValue": "PIN ชั้นเรียน {pin}",
    "join.studentTitle": "กรอกรหัสนักเรียนหรือรหัสกู้คืน",
    "join.studentDescription":
      "ใช้รหัสส่วนตัวที่ครูให้ หรือรหัสกู้คืนที่บันทึกไว้ เพื่อเข้าร่วมด้วยรายชื่อเดิม รหัสประจำชั้น เช่น CLS-01 ไม่ใช่รหัสเข้าใช้งาน",
    "join.studentLabel": "รหัสนักเรียนหรือรหัสกู้คืน",
    "join.studentValidation": "กรอกรหัสนักเรียนหรือรหัสกู้คืนให้ครบ",
    "join.selfRegisterTitle": "เข้าร่วมครั้งแรก",
    "join.selfRegisterDescription":
      "กรอกชื่อหรือชื่อเล่นที่ครูจำได้ ระบบจะเชื่อมชั้นเรียนกับอุปกรณ์นี้",
    "join.checkingDevice": "กำลังตรวจสอบว่าอุปกรณ์นี้เคยเข้าร่วมชั้นเรียนแล้วหรือไม่",
    "join.nameLabel": "ชื่อหรือชื่อเล่น",
    "join.nameValidation": "กรอกชื่อหรือชื่อเล่นไม่เกิน 80 ตัวอักษร",
    "join.nameTaken": "มีผู้ใช้ชื่อนี้แล้ว กรุณาใช้ชื่ออื่นที่ครูจำได้",
    "join.registrationLocked": "ครูปิดรับนักเรียนใหม่แล้ว",
    "join.closed": "ชั้นเรียนนี้ปิดแล้ว",
    "join.useRecovery": "มีรหัสนักเรียนหรือรหัสกู้คืนแล้วใช่ไหม?",
    "join.newStudent": "กลับไปเข้าร่วมครั้งแรก",
    "join.recoveryLabel": "รหัสนักเรียนหรือรหัสกู้คืน",
    "join.recoveryValidation": "กรอกรหัสนักเรียนที่ครูให้ หรือรหัสกู้คืนที่ได้รับจาก ConLit",
    "join.invalidRecovery": "PIN ชั้นเรียนหรือรหัสนักเรียน/รหัสกู้คืนไม่ถูกต้อง",
    "join.recoverAction": "เข้าร่วมชั้นเรียน",
    "join.saveRecoveryTitle": "บันทึกรหัสกู้คืนของคุณ",
    "join.saveRecoveryDescription":
      "ถ่ายภาพหน้าจอหรือคัดลอกรหัสนี้ไว้ใช้เมื่อเปลี่ยนอุปกรณ์ ระบบจะแสดงรหัสนี้เพียงครั้งเดียว",
    "join.classStudentId": "รหัสประจำชั้นของคุณ: {id}",
    "join.copyRecovery": "คัดลอกรหัสกู้คืน",
    "join.savedRecovery": "ฉันบันทึกรหัสแล้ว",
    "join.unable": "เข้าร่วมไม่ได้",
    "join.joining": "กำลังเข้าร่วม...",
    "join.action": "เข้าร่วมชั้นเรียน",
    "join.differentPin": "ใช้ PIN อื่น",
    "join.genericError": "ไม่สามารถเข้าร่วมชั้นเรียนนี้ได้",
    "join.alreadyLinked": "รหัสนักเรียนนี้เชื่อมกับอุปกรณ์อื่นแล้ว กรุณาขอให้ครูรีเซ็ตรหัส",
    "join.deviceLinked": "อุปกรณ์นี้เชื่อมกับนักเรียนคนอื่นอยู่ กรุณาออกจากกิจกรรมเดิมก่อน",
    "join.staffSignedIn": "กรุณาออกจากบัญชีบุคลากรก่อนเข้าร่วมในฐานะนักเรียน",
    "notFound.title": "ไม่พบหน้า",
    "notFound.description": "ไม่มีหน้าที่คุณต้องการ",
    "login.title": "เข้าสู่ระบบสำหรับบุคลากร",
    "login.description": "ครูและนักวิจัยเข้าสู่ระบบด้วยบัญชีบุคลากร ConLit",
    "login.email": "อีเมล",
    "login.password": "รหัสผ่าน",
    "login.failed": "เข้าสู่ระบบไม่สำเร็จ",
    "login.action": "เข้าสู่ระบบ",
    "platform.dashboard": "ภาพรวมแพลตฟอร์ม",
    "platform.dashboardDescription": "ติดตามการใช้งานและดูแลสิทธิ์โดยไม่เปิดเผยคำตอบรายบุคคล",
    "platform.organisations": "องค์กร",
    "platform.activeStaff": "บุคลากรที่ใช้งานอยู่",
    "platform.pendingStaff": "คำเชิญที่รอตอบรับ",
    "platform.suspendedStaff": "บัญชีที่ระงับ",
    "platform.studies": "โครงการวิจัย",
    "platform.classes": "ชั้นเรียน",
    "platform.openRooms": "ห้องเรียนที่เปิดอยู่",
    "platform.participants": "นักเรียนที่เข้าร่วม",
    "platform.completedAssessments": "แบบทดสอบที่ทำเสร็จ",
    "platform.privacyTitle": "จำกัดการเข้าถึงข้อมูลนักเรียน",
    "platform.privacyDescription":
      "ผู้ดูแลแพลตฟอร์มเห็นเฉพาะจำนวนรวม ไม่สามารถเปิดคำตอบหรือข้อมูลรายบุคคลได้",
    "platform.organisationsDescription": "สร้างและดูแลองค์กรกับโครงการวิจัยพื้นฐาน",
    "platform.createOrg": "สร้างองค์กร",
    "platform.orgName": "ชื่อองค์กร",
    "platform.orgSlug": "รหัส URL ภาษาอังกฤษ",
    "platform.orgCounts": "บุคลากร {staff} · ชั้นเรียน {classes} · ห้องเปิด {rooms}",
    "platform.createStudy": "สร้างโครงการวิจัย",
    "platform.studyTitle": "ชื่อโครงการวิจัย",
    "platform.studyDescription": "คำอธิบายโครงการ",
    "platform.consentRequired": "ต้องบันทึกความยินยอม",
    "platform.selectOrg": "เลือกองค์กร",
    "platform.create": "สร้าง",
    "platform.save": "บันทึก",
    "platform.archive": "เก็บถาวร",
    "platform.archiveConfirm": "เก็บองค์กรนี้ถาวรหรือไม่",
    "platform.archiveStudyConfirm": "เก็บโครงการวิจัยนี้ถาวรหรือไม่",
    "platform.staff": "บัญชีบุคลากร",
    "platform.staffDescription": "เชิญครูและนักวิจัย รวมถึงดูแลสิทธิ์และการกู้คืนบัญชี",
    "platform.inviteStaff": "เชิญบุคลากร",
    "platform.displayName": "ชื่อที่แสดง",
    "platform.teacher": "ครู",
    "platform.researcher": "นักวิจัย",
    "platform.createInvite": "สร้างลิงก์เชิญ",
    "platform.searchStaff": "ค้นหาชื่อหรืออีเมล",
    "platform.noStaff": "ยังไม่มีบัญชีบุคลากร",
    "platform.staffMember": "บุคลากร",
    "platform.organisation": "องค์กร",
    "platform.role": "บทบาทและโครงการ",
    "platform.status": "สถานะ",
    "platform.actions": "การดำเนินการ",
    "platform.pagination": "หน้า {page} จาก {pages} · ทั้งหมด {count} บัญชี",
    "platform.previousPage": "ก่อนหน้า",
    "platform.nextPage": "ถัดไป",
    "platform.status.invited": "รอตอบรับ",
    "platform.status.active": "ใช้งานอยู่",
    "platform.status.suspended": "ระงับแล้ว",
    "platform.updateAccess": "อัปเดตสิทธิ์",
    "platform.roleConfirm": "ยืนยันการเปลี่ยนบทบาทและสิทธิ์โครงการวิจัยหรือไม่",
    "platform.newInviteLink": "สร้างลิงก์เชิญใหม่",
    "platform.revoke": "ยกเลิกคำเชิญ",
    "platform.revokeConfirm": "ยกเลิกคำเชิญและบัญชีที่ยังไม่เปิดใช้งานหรือไม่",
    "platform.recoveryLink": "สร้างลิงก์กู้คืน",
    "platform.suspend": "ระงับบัญชี",
    "platform.suspendReason": "ระบุเหตุผลที่ระงับบัญชี",
    "platform.reactivate": "เปิดใช้งานอีกครั้ง",
    "platform.linkReady": "ลิงก์พร้อมส่ง",
    "platform.linkOnce": "คัดลอกและส่งผ่านช่องทางส่วนตัว ลิงก์จะหมดอายุภายใน 24 ชั่วโมง",
    "platform.secureLink": "ลิงก์ตั้งค่าบัญชีแบบใช้ครั้งเดียว",
    "platform.copyLink": "คัดลอกลิงก์",
    "platform.copiedLink": "คัดลอกแล้ว",
    "platform.copySuccess": "คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว",
    "platform.copyFailed": "คัดลอกอัตโนมัติไม่ได้ กรุณาเลือกลิงก์ด้านบนแล้วคัดลอกด้วยตนเอง",
    "platform.done": "เสร็จแล้ว",
    "platform.actionFailed": "ดำเนินการไม่สำเร็จ",
    "platform.audit": "ประวัติการดูแลระบบ",
    "platform.auditDescription": "การเปลี่ยนแปลงบัญชี องค์กร และโครงการวิจัยล่าสุด",
    "platform.searchAudit": "ค้นหาการดำเนินการ",
    "account.newPassword": "รหัสผ่านใหม่",
    "account.confirmPassword": "ยืนยันรหัสผ่าน",
    "account.acceptTitle": "เปิดใช้งานบัญชีบุคลากร",
    "account.acceptDescription": "ตรวจสอบชื่อและตั้งรหัสผ่านเพื่อเริ่มใช้งาน ConLit",
    "account.activate": "เปิดใช้งานบัญชี",
    "account.recoverTitle": "ตั้งรหัสผ่านใหม่",
    "account.recoverDescription": "ตั้งรหัสผ่านใหม่สำหรับบัญชีบุคลากรของคุณ",
    "account.savePassword": "บันทึกรหัสผ่านใหม่",
    "account.invalidLink": "ลิงก์ไม่ถูกต้องหรือหมดอายุ",
    "account.invalidLinkDescription": "กรุณาขอลิงก์ใหม่จากผู้ดูแลแพลตฟอร์ม",
    "account.setupFailed": "ไม่สามารถตั้งค่าบัญชีได้",
    "account.disabledTitle": "บัญชีนี้ถูกระงับ",
    "account.disabledDescription": "กรุณาติดต่อผู้ดูแลแพลตฟอร์มหากต้องการกลับมาใช้งาน",
  },
  en: {
    "session.selectClasses": "Select classes",
    "session.selectedClasses": "Selected classes",
    "session.removeClass": "Remove {name}",
    "session.noClasses": "No classes available",
    "session.shuffleAssessments": "Shuffle pre-test and post-test questions and answer options",
    "session.shuffleHelp":
      "Uncheck to give every student in these classrooms the same question and answer option order for each test.",
    "session.openTab": "Open sessions",
    "session.closedTab": "Closed sessions",
    "session.noOpenGroups": "No open sessions",
    "session.noClosedGroups": "No closed sessions",
    "session.studentCount": "{count} students",
    "session.noStudents": "No students have joined yet",
    "session.showMore": "Show more",
    "session.showLess": "Show less",

    "language.label": "Language",
    "language.thai": "ไทย",
    "language.english": "English",
    "nav.constitution": "Explore the constitution",
    "nav.about": "About ConLit",
    "nav.join": "Join a classroom",
    "nav.studentDashboard": "Activity dashboard",
    "nav.teacher": "Teacher",
    "nav.researcher": "Researcher",
    "nav.admin": "Administrator",
    "nav.platform": "Platform admin",
    "nav.signIn": "Staff sign in",
    "nav.enterPin": "Enter a PIN",
    "nav.signOut": "Sign out",
    "nav.leaveDevice": "Leave this device",
    "nav.primary": "Primary navigation",
    "nav.mobile": "Primary mobile navigation",
    "nav.open": "Open menu",
    "nav.close": "Close menu",
    "workspace.teacher": "Teacher workspace",
    "workspace.researcher": "Researcher workspace",
    "workspace.admin": "Administrator workspace",
    "workspace.platform": "Platform administration",
    "workspace.dashboard": "Overview",
    "workspace.users": "Staff accounts",
    "workspace.audit": "Audit history",
    "workspace.sessions": "Learning sessions",
    "workspace.classes": "Classes",
    "workspace.studies": "Assigned studies",
    "workspace.organisations": "Organisations",
    "student.activity": "Student activity",
    "footer.tagline": "ConLit · Constitutional literacy through accessible civic learning",
    "common.loading": "Loading",
    "common.retry": "Try again",
    "common.refresh": "Check status again",
    "common.backToActivities": "Back to activities",
    "common.comingSoon": "Coming soon",
    "common.locked": "Locked",
    "common.available": "Available",
    "common.inProgress": "In progress",
    "common.completed": "Completed",
    "common.open": "Open",
    "common.closed": "Closed",
    "security.checking": "Completing the security check…",
    "security.unavailable": "The security check is unavailable. Refresh the page and try again.",
    "error.genericTitle": "Something went wrong",
    "error.genericDescription": "This action is unavailable right now. Please try again.",
    "error.pageTitle": "We could not load this page",
    "error.pageDescription": "Return to the ConLit home page and try again.",
    "error.unauthorisedTitle": "Access unavailable",
    "error.unauthorisedDescription": "Your account cannot open this area.",
    "error.returnHome": "Return home",
    "student.loadingRoom": "Loading your classroom",
    "student.unavailable": "Student session unavailable",
    "student.joinAgain": "Join the classroom again.",
    "student.welcome": "Welcome, {name}",
    "student.dashboardTitle": "My activity menu",
    "student.dashboardDescription":
      "Complete each stage in order and wait for your teacher to open the post-test.",
    "student.preTitle": "1. Pre-test",
    "student.preDescription": "Check your knowledge before starting the learning activities.",
    "student.learnTitle": "2. Self-directed learning",
    "student.learnDescription": "Explore the constitution and practise with learning activities.",
    "student.postTitle": "3. Post-test",
    "student.postDescription": "Review your knowledge after the learning activities.",
    "student.startPre": "Start the pre-test",
    "student.resumePre": "Resume the pre-test",
    "student.startPost": "Start the post-test",
    "student.resumePost": "Resume the post-test",
    "student.viewResult": "View score",
    "student.preRequired": "Complete the pre-test first",
    "student.teacherLocked": "Waiting for your teacher to open the post-test",
    "student.constitutionTitle": "Constitution library",
    "student.constitutionDescription": "Search and read constitutional articles by topic.",
    "student.mappingTitle": "Rights matching activity",
    "student.mappingDescription": "Match a civic situation to the relevant right.",
    "student.scenarioTitle": "Branching scenario",
    "student.scenarioDescription": "Read each scenario and explain your view.",
    "student.resumeScenario": "Continue activity",
    "student.viewCompletion": "View submission status",
    "student.flashcardsTitle": "Review flashcards",
    "student.openLearning": "Start learning",
    "student.noLearning": "No learning activities are assigned to this classroom yet.",
    "consent.loading": "Loading consent information",
    "consent.title": "Research participation",
    "consent.description":
      "You can take part in the learning activity whether you agree or decline. Agreeing allows your pseudonymous results to be included in approved study statistics. Researchers do not receive your classroom pseudonym, student code, or login identity.",
    "consent.saveError": "We could not save your choice",
    "consent.agree": "I agree",
    "consent.decline": "Continue without research",
    "assessment.submitted": "Assessment submitted",
    "assessment.score": "Score: {earned} out of {total}",
    "assessment.percentage": "{percentage}%",
    "assessment.review": "Review answers",
    "assessment.correct": "Correct",
    "assessment.points": "{earned} out of {total} points",
    "assessment.correctAnswer": "Correct answer: {answer}",
    "assessment.easy": "Easy",
    "assessment.advanced": "Advanced",
    "assessment.questionProgress": "Question {current} of {total}",
    "assessment.chooseOne": "Choose one answer",
    "assessment.previous": "Previous",
    "assessment.next": "Next",
    "assessment.submit": "Submit answers",
    "assessment.submitting": "Submitting...",
    "assessment.submitError": "Could not submit answers",
    "assessment.notFound": "Assessment not found",
    "assessment.noQuestions": "No questions found",
    "assessment.noQuestionsDescription": "This assessment does not contain questions yet.",
    "assessment.classNotFound": "Classroom not found",
    "assessment.invalidLink": "This link does not contain a classroom identifier.",
    "assessment.loading": "Loading assessment",
    "assessment.openError": "Could not open assessment",
    "assessment.alreadyCompleted": "You already completed this assessment",
    "assessment.locked": "Your teacher has not opened the post-test yet.",
    "assessment.preRequired": "Complete the pre-test before starting the post-test.",
    "scenario.loading": "Loading scenario activity",
    "scenario.notFound": "Scenario activity not found",
    "scenario.openError": "Could not open scenario activity",
    "scenario.progress": "Scenario {current} of {total}",
    "scenario.answerHelp": "Write your response ({count}/{max} characters)",
    "scenario.submit": "Submit all responses",
    "scenario.submitting": "Submitting...",
    "scenario.submitError": "Could not submit responses",
    "scenario.completeTitle": "Responses submitted",
    "scenario.completeDescription": "Thank you for completing every scenario.",
    "mapping.title": "Match a civic situation to a right",
    "mapping.description":
      "Drag the card on the canvas or use the keyboard-accessible controls below.",
    "mapping.situation": "A student speaks peacefully",
    "mapping.expression": "Freedom of expression",
    "mapping.privacy": "Privacy",
    "mapping.keyboard": "Keyboard alternative",
    "mapping.instruction": "Choose the right that matches “A student speaks peacefully”.",
    "mapping.check": "Check mapping",
    "mapping.reset": "Reset",
    "mapping.correct": "Correct: peaceful speech concerns expression.",
    "mapping.incorrect": "Try again: consider which right protects peaceful speech.",
    "session.loading": "Loading learning sessions",
    "session.title": "Learning sessions",
    "session.description":
      "Open the same activity as a separate PIN-protected room for every selected class.",
    "session.openRooms": "Open classroom rooms",
    "session.sessionTitle": "Session title",
    "session.difficulty": "Assessment difficulty",
    "session.easy": "Easy",
    "session.advanced": "Advanced",
    "session.study": "Study (optional)",
    "session.noStudy": "No research study",
    "session.classes": "Classes",
    "session.learningActivities": "Learning activities",
    "session.learningHelp": "Example learning activities are selected by default.",
    "session.scenario": "Branching scenario (coming soon)",
    "session.flashcards": "Flashcards (coming soon)",
    "session.mapping": "Matching activity",
    "session.module": "Learning module",
    "session.openCount": "Open {count} classrooms",
    "session.openError": "Could not open rooms",
    "session.viewRooms": "View rooms",
    "session.noGroups": "No session groups yet",
    "session.statsLoading": "Loading classroom statistics",
    "session.unavailable": "Session unavailable",
    "session.liveStats": "Live room statistics refresh every ten seconds.",
    "session.joined": "Joined",
    "session.preComplete": "Pre-tests complete",
    "session.scenarioComplete": "Scenario activities submitted",
    "session.roomScenarioComplete": "{count} scenario activities submitted",
    "session.postComplete": "Post-tests complete",
    "session.pin": "PIN {pin}",
    "session.joinedStatus": "{count} joined · {status}",
    "session.preAverage": "Pre average",
    "session.postAverage": "Post average",
    "session.pairedGain": "Paired gain",
    "session.studentProgress": "Student progress",
    "session.studentScores": "Pre {pre} · Post {post}",
    "session.openJoin": "Open join page",
    "session.shareRoom": "Ask students to scan this QR code or enter the PIN.",
    "session.joinQr": "Classroom join QR code",
    "session.copyJoinLink": "Copy join link",
    "session.registrationOpen": "Accepting new students",
    "session.registrationLocked": "New registrations locked",
    "session.lockRegistration": "Lock new registrations",
    "session.unlockRegistration": "Accept new registrations",
    "session.manageRoster": "Manage roster",
    "session.closeRoom": "Close room",
    "session.reopenRoom": "Reopen room",
    "session.postLocked": "Post-test locked",
    "session.postEnabled": "Post-test enabled",
    "session.enablePost": "Enable post-test",
    "session.disablePost": "Disable post-test",
    "session.enableAllPost": "Enable post-test for all rooms",
    "session.disableAllPost": "Disable post-test for all rooms",
    "session.updateError": "Could not update status",
    "class.loading": "Loading classes",
    "class.action": "Action",
    "class.loadError": "Could not load classes",
    "class.retry": "Retry",
    "class.paginationLabel": "Class pagination",
    "class.pagination": "Page {page} of {pages} · {count} classes",
    "class.previousPage": "Previous",
    "class.nextPage": "Next",
    "class.backToClasses": "Back to classes",
    "class.codeInstructions":
      "Ask each student to open the session QR link or enter its classroom PIN, choose “Have a student or recovery code?”, then enter their private code below. Keep each student’s code private.",
    "class.resetHelp":
      "If a student loses their code, reset access to issue a new code for their existing roster entry while preserving learning progress.",
    "class.title": "Your classes",
    "class.description": "Only classes owned by your account appear here.",
    "class.create": "Create a class",
    "class.name": "Class name",
    "class.prefix": "Class prefix",
    "class.prefixTitle": "Class student IDs",
    "class.prefixHelp":
      "Use 2–5 English letters or numbers. You can edit it before the first student is added. Class IDs such as CLS-01 identify roster entries; they are not login codes.",
    "class.savePrefix": "Save prefix",
    "class.year": "Academic year",
    "class.createAction": "Create",
    "class.createError": "Could not create class",
    "class.yearMissing": "Academic year not set",
    "class.manageRoster": "Manage roster",
    "class.none": "No classes yet",
    "class.noneDescription": "Create your first owned classroom above.",
    "class.rosterLoading": "Loading roster",
    "class.rosterTitle": "Class roster",
    "class.rosterDescription":
      "Students who join by name are added automatically. You can also add students in advance. Private codes are shown only when created or reset.",
    "class.addPseudonyms": "Add students in advance (optional)",
    "class.addHelp":
      "Enter one name or nickname per line, up to 100 at a time. Students added in advance should use their issued code to join their existing roster entry.",
    "class.issueCodes": "Create student access codes",
    "class.copyCodes": "Print or copy these codes now",
    "class.students": "Students",
    "class.deviceLinked": "Device linked",
    "class.notJoined": "Not joined",
    "class.reset": "Reset access",
    "class.rename": "Rename",
    "class.saveName": "Save name",
    "class.archive": "Remove",
    "class.archiveConfirm":
      "Remove this student from the active roster? Existing activity data will be retained.",
    "research.loading": "Loading assigned studies",
    "research.title": "Assigned studies",
    "research.description":
      "Only studies explicitly assigned to your researcher account appear here.",
    "research.none": "No assigned studies",
    "research.statsLoading": "Loading research statistics",
    "research.unavailable": "Study unavailable",
    "research.statsTitle": "Study classroom statistics",
    "research.statsDescription":
      "Across all teachers · consent-aware · cells below five participants are suppressed.",
    "research.totalSuppressed": "Study total suppressed",
    "research.eligible": "{count} eligible participations",
    "research.noIdentities": "Room-level results never include roster identities or student rows.",
    "research.belowFive": "Fewer than 5 eligible participants",
    "research.suppressed": "Results suppressed",
    "research.fiveRequired": "At least five eligible participants are required.",
    "home.eyebrow": "Learn rights. Practise choices.",
    "home.title": "Civic learning built for participation.",
    "home.description":
      "ConLit helps students explore civic situations, while teachers and researchers create evidence-informed learning experiences.",
    "home.join": "Join a classroom session",
    "home.explore": "Explore ConLit",
    "home.constitutionDescription":
      "Search articles, browse chapters, and read source-verified constitutional text.",
    "home.constitutionAction": "Start exploring",
    "home.audiences": "Designed for learning communities",
    "home.students": "Students",
    "home.studentsDescription": "Join pseudonymously and learn through choices.",
    "home.teachers": "Teachers",
    "home.teachersDescription": "Build sessions and adapt content for learners.",
    "home.researchers": "Researchers",
    "home.researchersDescription": "Study engagement with privacy-aware data.",
    "about.title": "About ConLit",
    "about.description":
      "ConLit is a content-driven constitutional literacy platform for students, educators, researchers, and administrators.",
    "privacy.title": "Privacy",
    "privacy.description":
      "ConLit is designed around pseudonymous participation, data minimisation, consent-aware research, and restricted exports.",
    "join.pinTitle": "Join a classroom session",
    "join.pinDescription":
      "You do not need an email account. Your teacher will give you a six-character PIN or QR link.",
    "join.pinLabel": "Classroom PIN",
    "join.pinHelp": "Letters and numbers only.",
    "join.pinValidation": "Enter the six-character classroom code",
    "join.continue": "Continue",
    "join.pinValue": "Classroom PIN {pin}",
    "join.studentTitle": "Enter your student or recovery code",
    "join.studentDescription":
      "Use the private code your teacher gave you or a saved recovery code to access your existing roster entry. A class ID such as CLS-01 is not an access code.",
    "join.studentLabel": "Student or recovery code",
    "join.studentValidation": "Enter your full student or recovery code",
    "join.selfRegisterTitle": "Join for the first time",
    "join.selfRegisterDescription":
      "Enter a name or nickname your teacher will recognise. This classroom identity will be linked to this device.",
    "join.checkingDevice": "Checking whether this device has joined the class before.",
    "join.nameLabel": "Name or nickname",
    "join.nameValidation": "Enter a name or nickname of no more than 80 characters.",
    "join.nameTaken":
      "That name is already in use. Choose another name your teacher will recognise.",
    "join.registrationLocked": "Your teacher has stopped new registrations.",
    "join.closed": "This classroom is closed.",
    "join.useRecovery": "Have a student or recovery code?",
    "join.newStudent": "Back to first-time join",
    "join.recoveryLabel": "Student or recovery code",
    "join.recoveryValidation":
      "Enter the student code from your teacher or the recovery code provided by ConLit.",
    "join.invalidRecovery": "The classroom PIN or student/recovery code is incorrect.",
    "join.recoverAction": "Join classroom",
    "join.saveRecoveryTitle": "Save your recovery code",
    "join.saveRecoveryDescription":
      "Take a screenshot or copy this code for use on a different device. ConLit shows it only once.",
    "join.classStudentId": "Your class ID: {id}",
    "join.copyRecovery": "Copy recovery code",
    "join.savedRecovery": "I saved the code",
    "join.unable": "Unable to join",
    "join.joining": "Joining...",
    "join.action": "Join classroom",
    "join.differentPin": "Use a different PIN",
    "join.genericError": "Could not join this classroom",
    "join.alreadyLinked":
      "This student code is linked to another device. Ask your teacher to reset it.",
    "join.deviceLinked": "This device is linked to another student. Leave that activity first.",
    "join.staffSignedIn": "Sign out of the staff account before joining as a student.",
    "notFound.title": "Page not found",
    "notFound.description": "The page you requested does not exist.",
    "login.title": "Staff sign in",
    "login.description": "Teachers and researchers use their ConLit staff account.",
    "login.email": "Email",
    "login.password": "Password",
    "login.failed": "Sign in failed",
    "login.action": "Sign in",
    "platform.dashboard": "Platform overview",
    "platform.dashboardDescription":
      "Monitor operations and access without exposing individual answers.",
    "platform.organisations": "Organisations",
    "platform.activeStaff": "Active staff",
    "platform.pendingStaff": "Pending invitations",
    "platform.suspendedStaff": "Suspended accounts",
    "platform.studies": "Research studies",
    "platform.classes": "Classes",
    "platform.openRooms": "Open rooms",
    "platform.participants": "Participating students",
    "platform.completedAssessments": "Completed assessments",
    "platform.privacyTitle": "Student access is restricted",
    "platform.privacyDescription":
      "Platform administrators see aggregate counts but cannot open individual answers or participant records.",
    "platform.organisationsDescription":
      "Create and maintain organisations and basic research studies.",
    "platform.createOrg": "Create organisation",
    "platform.orgName": "Organisation name",
    "platform.orgSlug": "English URL identifier",
    "platform.orgCounts": "{staff} staff · {classes} classes · {rooms} open rooms",
    "platform.createStudy": "Create research study",
    "platform.studyTitle": "Study title",
    "platform.studyDescription": "Study description",
    "platform.consentRequired": "Consent recording required",
    "platform.selectOrg": "Select organisation",
    "platform.create": "Create",
    "platform.save": "Save",
    "platform.archive": "Archive",
    "platform.archiveConfirm": "Archive this organisation?",
    "platform.archiveStudyConfirm": "Archive this research study?",
    "platform.staff": "Staff accounts",
    "platform.staffDescription": "Invite teachers and researchers and manage access and recovery.",
    "platform.inviteStaff": "Invite staff",
    "platform.displayName": "Display name",
    "platform.teacher": "Teacher",
    "platform.researcher": "Researcher",
    "platform.createInvite": "Create invitation link",
    "platform.searchStaff": "Search name or email",
    "platform.noStaff": "No staff accounts yet",
    "platform.staffMember": "Staff member",
    "platform.organisation": "Organisation",
    "platform.role": "Role and studies",
    "platform.status": "Status",
    "platform.actions": "Actions",
    "platform.pagination": "Page {page} of {pages} · {count} accounts",
    "platform.previousPage": "Previous",
    "platform.nextPage": "Next",
    "platform.status.invited": "Invitation pending",
    "platform.status.active": "Active",
    "platform.status.suspended": "Suspended",
    "platform.updateAccess": "Update access",
    "platform.roleConfirm": "Confirm this role and study-access change?",
    "platform.newInviteLink": "Generate new invitation link",
    "platform.revoke": "Revoke invitation",
    "platform.revokeConfirm": "Revoke this invitation and unused account?",
    "platform.recoveryLink": "Generate recovery link",
    "platform.suspend": "Suspend account",
    "platform.suspendReason": "Enter the reason for suspending this account",
    "platform.reactivate": "Reactivate",
    "platform.linkReady": "Secure link ready",
    "platform.linkOnce": "Copy and send it privately. The link expires in 24 hours.",
    "platform.secureLink": "One-time account setup link",
    "platform.copyLink": "Copy link",
    "platform.copiedLink": "Copied",
    "platform.copySuccess": "The link has been copied to your clipboard.",
    "platform.copyFailed": "Automatic copying failed. Select the link above and copy it manually.",
    "platform.done": "Done",
    "platform.actionFailed": "Action failed",
    "platform.audit": "Administration history",
    "platform.auditDescription": "Recent staff, organisation, and study changes.",
    "platform.searchAudit": "Search actions",
    "account.newPassword": "New password",
    "account.confirmPassword": "Confirm password",
    "account.acceptTitle": "Activate your staff account",
    "account.acceptDescription": "Confirm your name and create a password to start using ConLit.",
    "account.activate": "Activate account",
    "account.recoverTitle": "Create a new password",
    "account.recoverDescription": "Set a new password for your staff account.",
    "account.savePassword": "Save new password",
    "account.invalidLink": "Link invalid or expired",
    "account.invalidLinkDescription": "Ask the platform administrator for a new secure link.",
    "account.setupFailed": "Account setup failed",
    "account.disabledTitle": "This account is suspended",
    "account.disabledDescription":
      "Contact the platform administrator if access should be restored.",
  },
} as const;

type TranslationKey = keyof (typeof translations)["th"];
type Variables = Record<string, string | number>;
type LocaleContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: TranslationKey, variables?: Variables) => string;
};

const storageKey = "conlit.locale";
const LocaleContext = createContext<LocaleContextValue>({
  locale: "th",
  setLocale: () => undefined,
  t: (key, variables = {}) =>
    Object.entries(variables).reduce(
      (message, [name, replacement]) => message.replaceAll(`{${name}}`, String(replacement)),
      translations.th[key] as string,
    ),
});

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocale] = useState<Locale>(() =>
    globalThis.localStorage?.getItem(storageKey) === "en" ? "en" : "th",
  );

  useEffect(() => {
    localStorage.setItem(storageKey, locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const value = useMemo<LocaleContextValue>(
    () => ({
      locale,
      setLocale,
      t: (key, variables = {}) =>
        Object.entries(variables).reduce(
          (message, [name, replacement]) => message.replaceAll(`{${name}}`, String(replacement)),
          translations[locale][key] as string,
        ),
    }),
    [locale],
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

// This hook intentionally shares the context module with its provider.
// eslint-disable-next-line react-refresh/only-export-components
export function useLocale() {
  return useContext(LocaleContext);
}
